import {
    LIST_AUDIENCE_CATEGORIES,
    LIST_AUDIENCE_CATEGORIES_SUCCESS,
    LIST_AUDIENCE_CATEGORIES_ERROR,
    ADD_AUDIENCE_CATEGORIES,
    SAVE_AUDIENCE_CATEGORIES,
    SAVE_AUDIENCE_CATEGORIES_SUCCESS,
    SAVE_AUDIENCE_CATEGORIES_ERROR,
    EDIT_AUDIENCE_CATEGORIES,
    UPDATE_AUDIENCE_CATEGORIES,
    UPDATE_AUDIENCE_CATEGORIES_SUCCESS,
    UPDATE_AUDIENCE_CATEGORIES_ERROR,
    DELETE_AUDIENCE_CATEGORIES,
    DELETE_AUDIENCE_CATEGORIES_SUCCESS,
    DELETE_AUDIENCE_CATEGORIES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    audienceCategories: null,
    error: null,
    loading: false,
    audienceCategorySelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_AUDIENCE_CATEGORIES:
            return {
                ...state,
                loading: true
            }
        case LIST_AUDIENCE_CATEGORIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_AUDIENCE_CATEGORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                audienceCategories: action.payload
            }
        case SAVE_AUDIENCE_CATEGORIES:
        case DELETE_AUDIENCE_CATEGORIES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_AUDIENCE_CATEGORIES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_AUDIENCE_CATEGORIES_ERROR:
        case UPDATE_AUDIENCE_CATEGORIES_ERROR:
        case DELETE_AUDIENCE_CATEGORIES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_AUDIENCE_CATEGORIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                audienceCategories: [...state.audienceCategories, action.payload]
            }
        case ADD_AUDIENCE_CATEGORIES:
            return {
                ...state,
                audienceCategorySelected: null,
                isEdit: false
            }
        case EDIT_AUDIENCE_CATEGORIES:
            return {
                ...state,
                audienceCategorySelected: action.payload,
                isEdit: true
            }
        case UPDATE_AUDIENCE_CATEGORIES_SUCCESS:
        case DELETE_AUDIENCE_CATEGORIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                audienceCategories: state.audienceCategories.map(audienceCategory => 
                    audienceCategory.id === action.payload.id ? audienceCategory = action.payload : audienceCategory
                ),
                audienceCategorySelected: null
            }
        // case DELETE_AUDIENCE_CATEGORIES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         audienceCategories: state.audienceCategories.filter( audienceCategory => audienceCategory.id !== action.payload)
        //     }
        default:
            return state;
    }
}